import { ParserHlp } from '../helpers/parser.helper';

/**
 * Used as source of replace tags for string, each tag must starts with $
 */
export interface ReplaceMap {
  [tag: `$${string}`]: string | number;
}

export interface ReplaceMapSanitized {
  [tag: `(dol)${string}`]: string | number;
}

/** Used as source to translate with replace functions */
export interface ReplaceObj {
  key: string;
  replaceMap: ReplaceMap;
}

export namespace ReplaceMap {
  /**
   * Sanitize replace map for database
   * @param {ReplaceMap} x
   * @return {ReplaceMapSanitized}
   */
  export function sanitize(x: ReplaceMap): ReplaceMapSanitized {
    return Object.fromEntries(Object.entries(x).map(([k, v]) => [ParserHlp.sanitizeKey(k), v]));
  }

  /**
   * Parse sanitized replace map
   * @param {ReplaceMapSanitized} x
   * @return {ReplaceMap}
   */
  export function parse(x: ReplaceMapSanitized): ReplaceMap {
    return Object.fromEntries(Object.entries(x).map(([k, v]) => [ParserHlp.deSanitizeKey(k), v]));
  }
}
